import React from 'react'
// import { usePopperTooltip } from 'react-popper-tooltip'
import 'react-popper-tooltip/dist/styles.css'

const InputNormal = ({title, id, name, onChange, value, disable, length, 
  // tooltipText, 
  placeHolder,
  isOblig
}) => {

  // const {
  //   getArrowProps,
  //   getTooltipProps,
  //   setTooltipRef,
  //   setTriggerRef,
  //   visible
  // } = usePopperTooltip()

  return (
    <div className="mb-1">
      <label 
        htmlFor={id} 
        className="form-label"
        
      >{title}
	{isOblig === true ? (<label style={{color: 'red'}}>*</label>):''}
	
      </label>
      {/* <i className="fas fa-info-circle ms-2"
      ref={setTriggerRef}></i> */}
      {/* {
        visible && (
          <div
            ref={setTooltipRef}
            {...getTooltipProps({ className: 'tooltip-container' })}
          >
          <div {...getArrowProps({ className: 'tooltip-arrow' })} />
            {tooltipText ? tooltipText : null}
          </div>
        )
      } */}
      <input 
        type="text" 
        id={id}
        maxLength={length ? length : null}
        placeholder={placeHolder ? placeHolder : null}
        onChange={onChange} 
        autoComplete="off"
        disabled={disable === true ? disable : null}
        name={name}
        value={value}
        className="form-control" />
    </div>
  )
}

export default InputNormal
